import clsx from 'clsx';

import type { CSSProperties, DetailedHTMLProps, FC, HTMLAttributes } from 'react';

import s from './ModalStack.module.css';

type ModalStackProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  alignContent?: CSSProperties['alignContent'];
  alignItems?: CSSProperties['alignItems'];
  alignSelf?: CSSProperties['alignSelf'];
  direction?: CSSProperties['flexDirection'];
  gap?: CSSProperties['gap'];
  justifyContent?: CSSProperties['justifyContent'];
  textAlign?: CSSProperties['textAlign'];
};

const ModalStack: FC<ModalStackProps> = ({
  alignContent = 'center',
  alignItems = 'center',
  alignSelf = 'stretch',
  className,
  direction = 'column',
  gap = '14px',
  justifyContent = 'center',
  style,
  textAlign = 'center',
  ...props
}) => (
  <div
    style={{
      alignContent,
      alignItems,
      alignSelf,
      flexDirection: direction,
      gap,
      justifyContent,
      textAlign,
      ...style,
    }}
    className={clsx(s.stack, className)}
    {...props}
  />
);

export { ModalStack };
